import { useMemo } from 'react';

import { CollectionQueryOptions, Filter, Nullable } from '../types';
import { SanitizedReservationConversionRate } from '../models';
import { updateStatistics } from '../components/ReservationConversionRate/common';
import { useReservationLogs } from './useReservationLogs';

export function useCorporateConversionRates(
  options?: CollectionQueryOptions,
  corporateCompanyId?: string,
  filterCompanyIds?: Nullable<string[]>
) {
  const corporateFilters = useMemo(
    () =>
      [
        ['corporateCompanyId', '==', corporateCompanyId],
        filterCompanyIds?.length
          ? ['companyId', 'in', filterCompanyIds]
          : undefined,
        ...(options?.filters || []),
      ] as Filter[],
    [corporateCompanyId, filterCompanyIds, options?.filters]
  );

  const { list: reservationLogs } = useReservationLogs({
    filters: corporateFilters,
  });

  const corporateConversionRates = useMemo(() => {
    const records = reservationLogs.reduce((acc, cur) => {
      const id = cur.companyId;
      const record = acc[id] || new SanitizedReservationConversionRate();

      if (!(record.id && record.companyName)) {
        record.id = id;
        record.companyName = cur.companyName;
      }

      updateStatistics(cur.endStatus, record);

      acc[cur.companyId] = record;
      return acc;
    }, {} as Record<string, SanitizedReservationConversionRate>);

    return Object.values(records);
  }, [reservationLogs]);

  return corporateConversionRates;
}
